import { useEffect } from "react";
import { usePerformance } from "../lib/performance";

export const SmoothScroll = () => {
  const { reducedEffects } = usePerformance();
  useEffect(() => {
    if (reducedEffects) return;
    let disposed = false, lenis, frame;
    const tick = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(tick);
    };
    const visibility = () => {
      cancelAnimationFrame(frame);
      if (lenis && !document.hidden) frame = requestAnimationFrame(tick);
    };
    const timer = setTimeout(async () => {
      try {
        const { default: Lenis } = await import("lenis");
        if (disposed) return;
        lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        document.addEventListener("visibilitychange", visibility);
        visibility();
      } catch {
        // Native scrolling remains available if this optional chunk cannot load.
      }
    }, 1200);
    return () => {
      disposed = true;
      clearTimeout(timer);
      cancelAnimationFrame(frame);
      document.removeEventListener("visibilitychange", visibility);
      lenis?.destroy();
    };
  }, [reducedEffects]);
  return null;
};